import React, { useState } from 'react'
import { X } from 'lucide-react'

interface WithdrawModalProps {
  visible: boolean
  onClose: () => void
  onConfirm: (amount: number, reason: string) => void
  loading?: boolean
}

export const WithdrawModal: React.FC<WithdrawModalProps> = ({
  visible,
  onClose,
  onConfirm,
  loading,
}) => {
  const [amount, setAmount] = useState(0)
  const [reason, setReason] = useState('')

  if (!visible) return null

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    onConfirm(amount, reason)
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Registrar Retiro</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm">Monto</label>
            <input
              type="number"
              step="1"
              value={amount}
              onChange={e => setAmount(Number(e.target.value))}
              className="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="text-sm">Motivo</label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              className="mt-1 w-full border rounded px-3 py-2"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gray-800 text-white rounded py-2 hover:bg-gray-700 disabled:opacity-50"
          >
            {loading ? 'Guardando...' : 'Registrar'}
          </button>
        </form>
      </div>
    </div>
  )
}
